import classNames from 'classnames';
import React from 'react';

import { PictureComponentV2 } from 'app/components/commons/PictureComponentV2/PictureComponentV2';
import { ChannelManager } from 'app/typings/channelManagers';
import { getDerbysoftSupplierConfig } from 'app/utils/channelManagers/derbysoft';

import { getChannelManagerConfig } from '../../../_common/ChannelManagerInfo/channelManagerConfig';

import styles from './ChannelManagerTag.module.scss';

type ChannelManagerTagProps = {
  variant: ChannelManager;
  supplierId?: string;
};

export const ChannelManagerTag: React.FC<ChannelManagerTagProps> = ({
  variant,
  supplierId,
}) => {
  const config =
    variant === ChannelManager.DERBYSOFT && supplierId
      ? getDerbysoftSupplierConfig(supplierId)
      : getChannelManagerConfig(variant);

  const label = config?.name ?? variant;
  const icon = config?.iconPath;
  const styleKey =
    variant === ChannelManager.DERBYSOFT && supplierId ? supplierId : variant;

  return (
    <div
      className={classNames(
        styles.channelManagerTag,
        styles[`variant-${styleKey}`]
      )}
    >
      {icon && (
        <div className={styles.thumbnail}>
          <PictureComponentV2 path={icon} alt={`${label} logo`} />
        </div>
      )}

      <span className={styles.label}>{label}</span>
    </div>
  );
};
